import React from "react";
import "./homepageLogo.css";

export const SpecialHeader = () => {
  return (
    <div className="scene">
      <div className="cube show-emcc">
        <div className="cube__face cube__face--E"></div>
        <div className="cube__face cube__face--M"></div>
        <div className="cube__face cube__face--C"></div>

        <div className="cube__face cube__face--xeter">XETER</div>
        <div className="cube__face cube__face--ath">ATH</div>
        <div className="cube__face cube__face--lub">LUB</div>
      </div>
    </div>
  );
};
